import { useState, useEffect } from "react";
import { supabase } from "./supabase";

const machines = [
  { id: 1, name: "Centro de Maquinado Vertical", brand: "Haas", model: "VF-2", year: 2018, hours: 4200, price: 42000, location: "Monterrey, NL", condition: "Bueno", category: "Centro de Maquinado", control: "Haas NGC", refacciones: true, desc: "Mesa 356x356mm, 30 herramientas, control Haas NGC actualizado 2022." },
  { id: 2, name: "Torno CNC", brand: "Mazak", model: "QT-200", year: 2016, hours: 7800, price: 28500, location: "Queretaro, QRO", condition: "Regular", category: "Torno", control: "Mazatrol", refacciones: true, desc: "Volteo 350mm, plato 8 pulgadas, torreta 12 herramientas." },
  { id: 3, name: "Fresadora CNC 3 Ejes", brand: "DMG Mori", model: "CMX 600V", year: 2020, hours: 1900, price: 58000, location: "CDMX", condition: "Excelente", category: "Fresadora", control: "Heidenhain TNC640", refacciones: false, desc: "Recorrido 600/450/450mm, husillo 15,000 RPM. Casi nueva." },
  { id: 4, name: "Taladradora Radial", brand: "Knuth", model: "RFB 50", year: 2014, hours: 3100, price: 8900, location: "Guadalajara, JAL", condition: "Bueno", category: "Taladro", control: "Siemens 808D", refacciones: true, desc: "Brazo 1600mm, columna 63mm, mesa giratoria 360 grados." },
  { id: 5, name: "Centro de Torneado CNC", brand: "Okuma", model: "LB3000", year: 2019, hours: 2600, price: 51000, location: "Chihuahua, CHIH", condition: "Excelente", category: "Torno", control: "Okuma OSP-P300L", refacciones: true, desc: "Diametro max 356mm, longitud max 1500mm." },
  { id: 6, name: "Rectificadora Plana", brand: "Jones & Shipman", model: "540X", year: 2012, hours: 9200, price: 14500, location: "San Luis Potosi, SLP", condition: "Regular", category: "Rectificadora", control: "Fanuc 0i", refacciones: false, desc: "Mesa magnetica 150x450mm, muela 200mm." },
];

const auctions = [
  { id: 101, name: "Torno CNC Okuma LB15", brand: "Okuma", model: "LB15", year: 2013, hours: 11200, startPrice: 12000, currentBid: 17400, bids: 8, location: "Monterrey, NL", condition: "Regular", category: "Torno", control: "Fanuc 21i", endsIn: "2d 14h", desc: "Excelente para produccion en serie. Volteo 300mm, control Fanuc original." },
  { id: 102, name: "Fresadora Vertical Bridgeport", brand: "Bridgeport", model: "Series I", year: 2009, hours: 6800, startPrice: 5500, currentBid: 9200, bids: 14, location: "CDMX", condition: "Bueno", category: "Fresadora", control: "Retrofiteado Siemens", endsIn: "18h 30m", desc: "Clasico de taller, retrofiteado con Siemens 828D. Documentacion completa." },
  { id: 103, name: "Centro de Maquinado Horizontal", brand: "Mazak", model: "HCN-5000", year: 2015, hours: 5400, startPrice: 35000, currentBid: 41000, bids: 5, location: "Queretaro, QRO", condition: "Bueno", category: "Centro de Maquinado", control: "Mazatrol SmoothG", endsIn: "4d 8h", desc: "Pallet 500x500mm, 60 herramientas, ideal para produccion automotriz." },
];

const BASE_PRICES = { "Centro de Maquinado": 55000, "Torno": 35000, "Fresadora": 50000, "Taladro": 12000, "Rectificadora": 18000 };
const CONTROL_BRANDS = ["Fanuc", "Siemens", "Heidenhain", "Mazatrol", "Haas NGC", "Haas Control Anterior", "Mitsubishi", "Okuma OSP", "Retrofiteado", "Otro"];
const categories = ["Todas", "Centro de Maquinado", "Torno", "Fresadora", "Taladro", "Rectificadora"];
const conditions = ["Todas", "Excelente", "Bueno", "Regular"];
const COMMISSION = 0.10;
const WA_NUMBER = "525579766237";
const EMAIL = "info@fierromx.com";

const S = {
  bg: "#0d1117", card: "#161c27", border: "#1e2d42", accent: "#d97706",
  text: "#e8edf5", muted: "#5a7a9a", dim: "#1e2d42",
  font: "'IBM Plex Mono', monospace", sans: "'IBM Plex Sans', sans-serif",
};

const Tag = ({ children, color }) => (
  <span style={{ background: (color || S.accent) + "22", color: color || S.accent, fontSize: 10, padding: "3px 9px", borderRadius: 20, letterSpacing: 1, textTransform: "uppercase", whiteSpace: "nowrap" }}>{children}</span>
);
const Label = ({ children }) => (
  <div style={{ fontSize: 10, letterSpacing: 2, color: S.muted, textTransform: "uppercase", marginBottom: 6 }}>{children}</div>
);
const condColor = (c) => ({ "Excelente": "#22c55e", "Bueno": "#f97316", "Regular": "#ef4444" }[c] || "#64748b");

const IconTarget = () => <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#d97706" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>;
const IconChart = () => <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#d97706" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>;
const IconShield = () => <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#d97706" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>;
const IconMegaphone = () => <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#d97706" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 11l19-9-9 19-2-8-8-2z"/></svg>;
const IconMail = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>;
const IconUser = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>;

// ─── AUTH MODAL ───────────────────────────────────────────────
function AuthModal({ onClose, onSuccess }) {
  const [mode, setMode] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [nombre, setNombre] = useState("");
  const [empresa, setEmpresa] = useState("");
  const [celular, setCelular] = useState("");
  const [ubicacion, setUbicacion] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleLogin = async () => {
    setLoading(true); setError("");
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) setError("Credenciales incorrectas. Intenta de nuevo.");
    else { onSuccess(); onClose(); }
    setLoading(false);
  };

  const handleRegister = async () => {
    if (!nombre || !empresa || !celular || !ubicacion || !email || !password) {
      setError("Todos los campos son obligatorios."); return;
    }
    if (password.length < 6) { setError("La contraseña debe tener al menos 6 caracteres."); return; }
    setLoading(true); setError("");
    const { data, error } = await supabase.auth.signUp({ email, password });
    if (error) { setError(error.message); setLoading(false); return; }
    if (data?.user) {
      await supabase.from("profiles").insert({
        id: data.user.id, email, nombre, empresa, telefono: celular, ciudad: ubicacion
      });
    }
    setSuccess("Cuenta creada. Revisa tu email para confirmar.");
    setLoading(false);
  };

  const inp = { width: "100%", background: S.bg, border: "1px solid " + S.dim, borderRadius: 8, color: S.text, padding: "12px", fontSize: 14, fontFamily: S.sans, boxSizing: "border-box", marginBottom: 12 };

  return (
    <div style={{ position: "fixed", inset: 0, background: "#000000ee", zIndex: 300, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }} onClick={onClose}>
      <div style={{ background: S.card, border: "1px solid " + S.accent, borderRadius: 16, padding: 36, maxWidth: 420, width: "100%", position: "relative", maxHeight: "90vh", overflowY: "auto" }} onClick={e => e.stopPropagation()}>
        <button onClick={onClose} style={{ position: "absolute", top: 16, right: 16, background: "none", border: "none", color: S.muted, fontSize: 20, cursor: "pointer" }}>✕</button>

        <div style={{ fontSize: 11, letterSpacing: 3, color: S.accent, textTransform: "uppercase", marginBottom: 8 }}>Acceso a FIERRO.MX</div>
        <h2 style={{ fontSize: 22, color: S.text, fontFamily: S.sans, margin: "0 0 24px" }}>
          {mode === "login" ? "Inicia sesión" : "Crea tu cuenta"}
        </h2>

        <div style={{ display: "flex", gap: 8, marginBottom: 24 }}>
          {["login", "register"].map(m => (
            <button key={m} onClick={() => { setMode(m); setError(""); setSuccess(""); }}
              style={{ flex: 1, background: mode === m ? S.accent : "none", color: mode === m ? "#000" : S.muted, border: "1px solid " + (mode === m ? S.accent : S.dim), borderRadius: 8, padding: "10px", fontSize: 12, fontWeight: 700, cursor: "pointer", letterSpacing: 1 }}>
              {m === "login" ? "Iniciar sesión" : "Registrarse"}
            </button>
          ))}
        </div>

        {mode === "register" && (
          <>
            <Label>Nombre completo *</Label>
            <input style={inp} placeholder="Juan García" value={nombre} onChange={e => setNombre(e.target.value)} />
            <Label>Empresa *</Label>
            <input style={inp} placeholder="Taller XYZ / Manufactura ABC" value={empresa} onChange={e => setEmpresa(e.target.value)} />
            <Label>Celular *</Label>
            <input style={inp} placeholder="+52 55 1234 5678" value={celular} onChange={e => setCelular(e.target.value)} />
            <Label>Ciudad / Estado *</Label>
            <input style={inp} placeholder="Monterrey, NL" value={ubicacion} onChange={e => setUbicacion(e.target.value)} />
          </>
        )}

        <Label>Correo electrónico *</Label>
        <input style={inp} type="email" placeholder="tu@correo.com" value={email} onChange={e => setEmail(e.target.value)} />
        <Label>Contraseña *</Label>
        <input style={inp} type="password" placeholder="Mínimo 6 caracteres" value={password} onChange={e => setPassword(e.target.value)} />

        {error && <div style={{ color: "#ef4444", fontSize: 12, marginBottom: 12 }}>{error}</div>}
        {success && <div style={{ color: "#22c55e", fontSize: 12, marginBottom: 12 }}>{success}</div>}

        <button onClick={mode === "login" ? handleLogin : handleRegister} disabled={loading}
          style={{ width: "100%", background: loading ? S.dim : S.accent, color: loading ? S.muted : "#000", border: "none", borderRadius: 8, padding: "14px", fontSize: 13, fontWeight: 700, cursor: loading ? "not-allowed" : "pointer", letterSpacing: 1, textTransform: "uppercase" }}>
          {loading ? "Procesando..." : mode === "login" ? "Entrar" : "Crear cuenta gratis"}
        </button>

        <div style={{ fontSize: 11, color: S.muted, textAlign: "center", marginTop: 16, lineHeight: 1.6 }}>
          Sin costo. Solo pagas 10% si vendes.<br />Tu información es privada y segura.
        </div>
      </div>
    </div>
  );
}  


// ─── PUBLISH FORM ─────────────────────────────────────────────
function PublishForm({ user, onClose }) {
  const [f, setF] = useState({ nombre: "", marca: "", modelo: "", anio: "", horas: "", precio: "", categoria: "", condicion: "", control: "", refacciones: "", ubicacion: "", descripcion: "" });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const set = (k, v) => setF(p => ({ ...p, [k]: v }));

  const handleSubmit = async () => {
    if (!f.nombre || !f.categoria || !f.precio || !f.condicion) { setError("Completa los campos obligatorios."); return; }
    setLoading(true); setError("");
    const { error } = await supabase.from("machines").insert({
      user_id: user.id,
      nombre: f.nombre, marca: f.marca, modelo: f.modelo,
      anio: parseInt(f.anio) || null, horas: parseInt(f.horas) || null,
      precio: parseFloat(f.precio), categoria: f.categoria,
      condicion: f.condicion, control: f.control,
      refacciones: f.refacciones === "si",
      ubicacion: f.ubicacion, descripcion: f.descripcion,
      status: "pending"
    });
    if (error) { setError("Error al publicar. Intenta de nuevo."); }
    else { setSuccess(true); }
    setLoading(false);
  };

  const inp = { width: "100%", background: S.bg, border: "1px solid " + S.dim, borderRadius: 8, color: S.text, padding: "10px 12px", fontSize: 13, fontFamily: S.sans, boxSizing: "border-box" };

  if (success) return (
    <div style={{ maxWidth: 560, margin: "0 auto", padding: "60px 24px", textAlign: "center" }}>
      <div style={{ fontSize: 48, marginBottom: 20 }}>✅</div>
      <h2 style={{ fontSize: 26, color: S.text, fontFamily: S.sans, marginBottom: 12 }}>Publicación enviada</h2>
      <p style={{ color: S.muted, fontSize: 14, lineHeight: 1.8, marginBottom: 32 }}>
        Recibimos tu máquina. La revisamos en menos de 24 horas y te confirmamos por email cuando esté activa en el catálogo.
      </p>
      <button onClick={onClose} style={{ background: S.accent, color: "#000", border: "none", borderRadius: 8, padding: "14px 32px", fontSize: 13, fontWeight: 700, cursor: "pointer" }}>
        Volver al inicio
      </button>
    </div>
  );

  return (
    <div style={{ maxWidth: 700, margin: "0 auto", padding: "48px 24px" }}>
      <div style={{ fontSize: 11, letterSpacing: 4, color: S.accent, textTransform: "uppercase", marginBottom: 10 }}>Nueva publicación</div>
      <h2 style={{ fontSize: 28, fontWeight: 800, color: S.text, margin: "0 0 8px", fontFamily: S.sans }}>Publica tu máquina</h2>
      <p style={{ color: S.muted, fontSize: 13, marginBottom: 32 }}>Campos con * son obligatorios. Tu publicación será revisada antes de aparecer en el catálogo.</p>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 16, marginBottom: 16 }}>
        {[
          { label: "Nombre de la máquina *", key: "nombre", type: "text", placeholder: "Centro de Maquinado Vertical" },
          { label: "Marca", key: "marca", type: "text", placeholder: "Haas, Mazak, DMG..." },
          { label: "Modelo", key: "modelo", type: "text", placeholder: "VF-2, QT-200..." },
          { label: "Año de fabricación", key: "anio", type: "number", placeholder: "2018" },
          { label: "Horas de uso", key: "horas", type: "number", placeholder: "4500" },
          { label: "Precio USD *", key: "precio", type: "number", placeholder: "35000" },
          { label: "Ubicación", key: "ubicacion", type: "text", placeholder: "Monterrey, NL" },
        ].map(fi => (
          <div key={fi.key}>
            <Label>{fi.label}</Label>
            <input type={fi.type} placeholder={fi.placeholder} value={f[fi.key]} onChange={e => set(fi.key, e.target.value)} style={inp} />
          </div>
        ))}

        {[
          { label: "Categoría *", key: "categoria", opts: Object.keys(BASE_PRICES) },
          { label: "Condición *", key: "condicion", opts: ["Excelente", "Bueno", "Regular"] },
          { label: "Control CNC", key: "control", opts: CONTROL_BRANDS },
          { label: "Refacciones disponibles", key: "refacciones", opts: ["si", "no"] },
        ].map(fi => (
          <div key={fi.key}>
            <Label>{fi.label}</Label>
            <select value={f[fi.key]} onChange={e => set(fi.key, e.target.value)} style={inp}>
              <option value="">Selecciona</option>
              {fi.opts.map(o => <option key={o} value={o}>{o}</option>)}
            </select>
          </div>
        ))}
      </div>

      <div style={{ marginBottom: 24 }}>
        <Label>Descripción técnica</Label>
        <textarea value={f.descripcion} onChange={e => set("descripcion", e.target.value)} placeholder="Describe el estado, mantenimientos, accesorios incluidos, motivo de venta..." rows={4}
          style={{ ...inp, resize: "vertical", lineHeight: 1.7 }} />
      </div>

      <div style={{ background: S.card, border: "1px solid " + S.dim, borderRadius: 10, padding: 16, marginBottom: 24, fontSize: 12, color: S.muted, lineHeight: 1.8 }}>
        <strong style={{ color: S.text }}>¿Cómo funciona?</strong><br />
        Tu publicación es <strong style={{ color: S.accent }}>gratuita</strong>. Solo cobramos el <strong style={{ color: S.accent }}>10% de comisión</strong> cuando la venta se concreta. Nosotros nos encargamos del marketing B2B.
      </div>

      {error && <div style={{ color: "#ef4444", fontSize: 12, marginBottom: 12 }}>{error}</div>}

      <div style={{ display: "flex", gap: 12 }}>
        <button onClick={onClose} style={{ flex: 1, background: "none", border: "1px solid " + S.dim, borderRadius: 8, color: S.muted, padding: 14, cursor: "pointer", fontSize: 13 }}>Cancelar</button>
        <button onClick={handleSubmit} disabled={loading}
          style={{ flex: 2, background: loading ? S.dim : S.accent, color: loading ? S.muted : "#000", border: "none", borderRadius: 8, padding: 14, fontSize: 13, fontWeight: 700, cursor: loading ? "not-allowed" : "pointer", letterSpacing: 1, textTransform: "uppercase" }}>
          {loading ? "Enviando..." : "Publicar máquina →"}
        </button>
      </div>
    </div>
  );
}

// ─── CARDS ────────────────────────────────────────────────────
function MachineCard({ m, onClick }) {
  const [hov, setHov] = useState(false);
  return (
    <div onClick={() => onClick(m)} onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}
      style={{ background: S.card, border: "1px solid " + (hov ? S.accent : S.border), borderRadius: 12, overflow: "hidden", cursor: "pointer", transition: "all 0.18s", transform: hov ? "translateY(-3px)" : "none" }}>
      {m.image && (
        <div style={{ width: "100%", height: 180, overflow: "hidden", background: S.dim }}>
          <img src={m.image} alt={m.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
        </div>
      )}
      <div style={{ padding: 20 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 12 }}>
          <Tag color={condColor(m.condition)}>{m.condition}</Tag>
          <span style={{ fontSize: 11, color: S.muted }}>📍 {m.location}</span>
        </div>
        <div style={{ fontSize: 15, fontWeight: 700, color: S.text, fontFamily: S.sans, marginBottom: 4, lineHeight: 1.3 }}>{m.name}</div>
        <div style={{ fontSize: 12, color: S.muted, marginBottom: 14 }}>{m.brand} {m.model} · {m.year} · {m.control}</div>
        <div style={{ borderTop: "1px solid " + S.dim, paddingTop: 12, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div>
            <div style={{ fontSize: 11, color: S.muted, marginBottom: 2 }}>Precio</div>
            <div style={{ fontSize: 22, fontWeight: 800, color: S.accent, fontFamily: S.font }}>${m.price.toLocaleString()} <span style={{ fontSize: 11, fontWeight: 400, color: S.muted }}>USD</span></div>
          </div>
          <span style={{ fontSize: 11, color: "#22c55e" }}>Ver detalle →</span>
        </div>
      </div>
    </div>
  );
}

function AuctionCard({ a, onBid }) {
  const [hov, setHov] = useState(false);
  const pct = Math.round((a.currentBid / (a.startPrice * 2)) * 100);
  const isEnding = a.endsIn.includes("h") && !a.endsIn.includes("d");
  return (
    <div onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}
      style={{ background: S.card, border: "1px solid " + (hov ? S.accent : isEnding ? "#ef444440" : S.border), borderRadius: 12, padding: 20, transition: "all 0.18s" }}>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 12 }}>
        <Tag color={condColor(a.condition)}>{a.condition}</Tag>
        <Tag color={isEnding ? "#ef4444" : "#f97316"}>⏱ {a.endsIn}</Tag>
      </div>
      <div style={{ fontSize: 15, fontWeight: 700, color: S.text, fontFamily: S.sans, marginBottom: 4 }}>{a.name}</div>
      <div style={{ fontSize: 12, color: S.muted, marginBottom: 16 }}>{a.brand} {a.model} · {a.year} · {a.control}</div>
      <div style={{ background: S.bg, borderRadius: 8, padding: 14, marginBottom: 14 }}>
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
          <div>
            <div style={{ fontSize: 10, color: S.muted, letterSpacing: 2, textTransform: "uppercase" }}>Puja actual</div>
            <div style={{ fontSize: 26, fontWeight: 900, color: S.accent, fontFamily: S.font }}>${a.currentBid.toLocaleString()}</div>
          </div>
          <div style={{ textAlign: "right" }}>
            <div style={{ fontSize: 10, color: S.muted, letterSpacing: 2, textTransform: "uppercase" }}>Inicio</div>
            <div style={{ fontSize: 15, color: S.text, fontFamily: S.font }}>${a.startPrice.toLocaleString()}</div>
          </div>
        </div>
        <div style={{ background: S.dim, borderRadius: 4, height: 4, overflow: "hidden" }}>
          <div style={{ width: Math.min(pct, 100) + "%", height: "100%", background: S.accent, borderRadius: 4 }} />
        </div>
        <div style={{ fontSize: 11, color: S.muted, marginTop: 6 }}>{a.bids} pujas · 📍 {a.location}</div>
      </div>
      <button onClick={() => onBid(a)} style={{ width: "100%", background: S.accent, color: "#000", border: "none", borderRadius: 8, padding: "12px", fontSize: 13, fontWeight: 700, cursor: "pointer", letterSpacing: 1, textTransform: "uppercase" }}>
        Pujar ahora
      </button>
    </div>
  );
}

function DetailModal({ m, onClose }) {
  if (!m) return null;
  return (
    <div style={{ position: "fixed", inset: 0, background: "#000000dd", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }} onClick={onClose}>
      <div style={{ background: S.card, border: "1px solid " + S.accent, borderRadius: 16, padding: 32, maxWidth: 540, width: "100%", position: "relative", maxHeight: "90vh", overflowY: "auto" }} onClick={e => e.stopPropagation()}>
        <button onClick={onClose} style={{ position: "absolute", top: 16, right: 16, background: "none", border: "none", color: S.muted, fontSize: 20, cursor: "pointer" }}>✕</button>
        <div style={{ display: "flex", gap: 8, marginBottom: 12, flexWrap: "wrap" }}>
          <Tag color={condColor(m.condition)}>{m.condition}</Tag>
          <Tag>{m.category}</Tag>
        </div>
        <h2 style={{ fontSize: 22, color: S.text, fontFamily: S.sans, margin: "0 0 4px" }}>{m.name}</h2>
        <div style={{ color: S.muted, fontSize: 13, marginBottom: 16 }}>{m.brand} {m.model} · {m.year}</div>
        <p style={{ color: "#94a3b8", fontSize: 13, lineHeight: 1.7, marginBottom: 20 }}>{m.desc}</p>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 20 }}>
          {[["Control", m.control], ["Ubicacion", m.location], ["Horas de uso", m.hours ? m.hours.toLocaleString() + " hrs" : "N/A"], ["Refacciones", m.refacciones ? "Disponibles" : "No disponibles"]].map(([k, v]) => (
            <div key={k} style={{ background: S.bg, borderRadius: 8, padding: 12 }}>
              <Label>{k}</Label>
              <div style={{ fontSize: 13, color: S.text }}>{v}</div>
            </div>
          ))}
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", background: S.bg, borderRadius: 10, padding: "16px 20px", flexWrap: "wrap", gap: 12 }}>
          <div>
            <Label>Precio</Label>
            <div style={{ fontSize: 28, fontWeight: 800, color: S.accent, fontFamily: S.font }}>${m.price ? m.price.toLocaleString() : "N/A"} USD</div>
          </div>
          <a href={`https://wa.me/${WA_NUMBER}?text=Hola, me interesa la maquina: ${m.name} ${m.brand} ${m.model} a $${m.price?.toLocaleString()} USD`} target="_blank" rel="noreferrer"
            style={{ background: "#25d366", color: "#fff", border: "none", borderRadius: 8, padding: "12px 20px", fontSize: 13, fontWeight: 700, cursor: "pointer", textDecoration: "none", display: "inline-block" }}>
            Contactar por WhatsApp
          </a>
        </div>
      </div>
    </div>
  );
}

function BidModal({ a, onClose }) {
  const [bid, setBid] = useState("");
  const min = a.currentBid + 500;
  const valid = parseInt(bid) >= min;
  return (
    <div style={{ position: "fixed", inset: 0, background: "#000000dd", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }} onClick={onClose}>
      <div style={{ background: S.card, border: "1px solid " + S.accent, borderRadius: 16, padding: 32, maxWidth: 420, width: "100%", maxHeight: "90vh", overflowY: "auto" }} onClick={e => e.stopPropagation()}>
        <div style={{ fontSize: 11, letterSpacing: 3, color: S.accent, textTransform: "uppercase", marginBottom: 8 }}>Subasta activa</div>
        <h2 style={{ fontSize: 20, color: S.text, fontFamily: S.sans, margin: "0 0 4px" }}>{a.name}</h2>
        <div style={{ color: S.muted, fontSize: 13, marginBottom: 24 }}>{a.brand} {a.model} · {a.year}</div>
        <div style={{ background: S.bg, borderRadius: 10, padding: 16, marginBottom: 20 }}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div><Label>Puja actual</Label><div style={{ fontSize: 24, fontWeight: 800, color: S.accent, fontFamily: S.font }}>${a.currentBid.toLocaleString()}</div></div>
            <div><Label>Tiempo restante</Label><div style={{ fontSize: 18, color: "#ef4444", fontFamily: S.font }}>{a.endsIn}</div></div>
          </div>
        </div>
        <Label>Tu puja (minimo ${min.toLocaleString()} USD)</Label>
        <input type="number" value={bid} onChange={e => setBid(e.target.value)} placeholder={min.toString()}
          style={{ width: "100%", background: S.bg, border: "1px solid " + (valid ? "#22c55e" : S.dim), borderRadius: 8, color: S.text, padding: "12px", fontSize: 16, fontFamily: S.font, boxSizing: "border-box", marginBottom: 16 }} />
        <div style={{ fontSize: 11, color: S.muted, marginBottom: 20 }}>Comision FIERRO (10% solo si ganas): ${valid ? Math.round(parseInt(bid) * COMMISSION).toLocaleString() : "—"} USD</div>
        <div style={{ display: "flex", gap: 10 }}>
          <button onClick={onClose} style={{ flex: 1, background: "none", border: "1px solid " + S.dim, borderRadius: 8, color: S.muted, padding: 12, cursor: "pointer", fontSize: 13 }}>Cancelar</button>
          <button disabled={!valid} style={{ flex: 2, background: valid ? S.accent : S.dim, color: valid ? "#000" : S.muted, border: "none", borderRadius: 8, padding: 12, fontSize: 13, fontWeight: 700, cursor: valid ? "pointer" : "not-allowed", letterSpacing: 1 }}>
            Confirmar puja →
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── VALUATION ────────────────────────────────────────────────
function Valuation() {
  const [f, setF] = useState({ category: "", brand: "", year: "", hours: "", condition: "", control: "", refacciones: "" });
  const [res, setRes] = useState(null);
  const set = (k, v) => setF(p => ({ ...p, [k]: v }));
  const ready = f.category && f.year && f.hours && f.condition;

  const calc = () => {
    const base = BASE_PRICES[f.category] || 30000;
    const age = new Date().getFullYear() - parseInt(f.year);
    const ageFactor = Math.max(0.3, 1 - age * 0.06);
    const hrs = parseInt(f.hours);
    const hrsFactor = hrs < 2000 ? 1.0 : hrs < 5000 ? 0.85 : hrs < 8000 ? 0.70 : 0.55;
    const condFactor = { "Excelente": 1.05, "Bueno": 0.90, "Regular": 0.72 }[f.condition] || 0.85;
    const refFactor = f.refacciones === "si" ? 1.04 : 0.97;
    const ctrlFactor = { "Fanuc": 1.06, "Siemens": 1.06, "Heidenhain": 1.08, "Mazatrol": 1.05, "Haas NGC": 1.04, "Haas Control Anterior": 0.96, "Okuma OSP": 1.04, "Mitsubishi": 1.02, "Retrofiteado": 0.88, "Otro": 0.95 }[f.control] || 1.0;
    const brandFactor = ["Haas", "Mazak", "DMG Mori", "Okuma", "Fanuc", "Makino", "Doosan"].includes(f.brand) ? 1.08 : 1.0;
    const val = base * ageFactor * hrsFactor * condFactor * refFactor * ctrlFactor * brandFactor;
    setRes({ low: Math.round(val * 0.88 / 500) * 500, mid: Math.round(val / 500) * 500, high: Math.round(val * 1.12 / 500) * 500, commission: Math.round(val * COMMISSION / 100) * 100 });
  };

  return (
    <div style={{ maxWidth: 660, margin: "0 auto", padding: "48px 24px" }}>
      <div style={{ fontSize: 11, letterSpacing: 4, color: S.accent, textTransform: "uppercase", marginBottom: 10 }}>Valuador de mercado</div>
      <h2 style={{ fontSize: 30, fontWeight: 800, color: S.text, margin: "0 0 8px", fontFamily: S.sans }}>¿Cuánto vale tu máquina?</h2>
      <p style={{ color: S.muted, fontSize: 14, marginBottom: 32, lineHeight: 1.7 }}>Modelo basado en precios reales del mercado mexicano.</p>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 16, marginBottom: 20 }}>
        {[
          { label: "Categoría", key: "category", type: "select", opts: Object.keys(BASE_PRICES) },
          { label: "Marca de máquina", key: "brand", type: "text", placeholder: "Haas, Mazak, DMG..." },
          { label: "Año de fabricación", key: "year", type: "number", placeholder: "2016" },
          { label: "Horas de uso", key: "hours", type: "number", placeholder: "4500" },
          { label: "Condición general", key: "condition", type: "select", opts: ["Excelente", "Bueno", "Regular"] },
          { label: "Control CNC", key: "control", type: "select", opts: CONTROL_BRANDS },
          { label: "Refacciones disponibles", key: "refacciones", type: "select", opts: ["si", "no"] },
        ].map(fi => (
          <div key={fi.key}>
            <Label>{fi.label}</Label>
            {fi.type === "select" ? (
              <select value={f[fi.key]} onChange={e => set(fi.key, e.target.value)}
                style={{ width: "100%", background: "#1a2535", border: "1px solid " + S.dim, borderRadius: 6, color: f[fi.key] ? S.text : S.muted, padding: "10px 12px", fontSize: 13, fontFamily: S.font }}>
                <option value="">Selecciona</option>
                {fi.opts.map(o => <option key={o} value={o}>{o}</option>)}
              </select>
            ) : (
              <input type={fi.type} placeholder={fi.placeholder} value={f[fi.key]} onChange={e => set(fi.key, e.target.value)}
                style={{ width: "100%", background: "#1a2535", border: "1px solid " + S.dim, borderRadius: 6, color: S.text, padding: "10px 12px", fontSize: 13, fontFamily: S.font, boxSizing: "border-box" }} />
            )}
          </div>
        ))}
      </div>
      <button onClick={calc} disabled={!ready}
        style={{ width: "100%", background: ready ? S.accent : S.dim, color: ready ? "#000" : S.muted, border: "none", borderRadius: 8, padding: 14, fontSize: 13, fontWeight: 700, cursor: ready ? "pointer" : "not-allowed", letterSpacing: 2, textTransform: "uppercase", marginBottom: 24 }}>
        Calcular valuación
      </button>
      {res && (
        <div style={{ background: S.bg, border: "1px solid " + S.accent, borderRadius: 12, padding: 28 }}>
          <Label>Rango de mercado estimado</Label>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))", gap: 10, marginBottom: 20 }}>
            {[["Conservador", res.low, S.muted], ["Valor justo", res.mid, S.accent], ["Óptimo", res.high, "#22c55e"]].map(([lbl, val, col]) => (
              <div key={lbl} style={{ textAlign: "center", background: S.card, borderRadius: 8, padding: "16px 8px", border: "1px solid " + col + "33" }}>
                <div style={{ fontSize: 10, color: S.muted, letterSpacing: 2, textTransform: "uppercase", marginBottom: 8 }}>{lbl}</div>
                <div style={{ fontSize: 22, fontWeight: 800, color: col }}>${val.toLocaleString()}</div>
                <div style={{ fontSize: 10, color: S.muted }}>USD</div>
              </div>
            ))}
          </div>
          <div style={{ background: S.card, borderRadius: 8, padding: 16, display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 10 }}>
            <div><Label>Comisión FIERRO (10%)</Label><div style={{ fontSize: 18, fontWeight: 700, color: S.text }}>${res.commission.toLocaleString()} USD</div></div>
            <div style={{ fontSize: 11, color: S.muted, maxWidth: 180, textAlign: "right", lineHeight: 1.7 }}>Solo pagas si vendes.</div>
          </div>
        </div>
      )}
    </div>
  );
}

// ─── QUIENES SOMOS ────────────────────────────────────────────
function QuienesSomos() {
  return (
    <div style={{ maxWidth: 860, margin: "0 auto", padding: "60px 24px" }}>
      <div style={{ fontSize: 11, letterSpacing: 4, color: S.accent, textTransform: "uppercase", marginBottom: 12 }}>Quiénes somos</div>
      <h2 style={{ fontSize: "clamp(26px, 4vw, 36px)", fontWeight: 800, color: S.text, margin: "0 0 24px", fontFamily: S.sans, lineHeight: 1.2 }}>
        La plataforma especializada en maquinaria CNC usada de México
      </h2>
      <p style={{ color: "#94a3b8", fontSize: 15, lineHeight: 1.9, marginBottom: 20 }}>
        FIERRO.MX nació para resolver un problema real del sector industrial mexicano: comprar y vender maquinaria CNC usada es lento, opaco y sin información confiable de precios. Los talleres rotan equipo, las empresas liquidan activos, y los compradores no tienen dónde encontrar opciones verificadas con valuación transparente.
      </p>
      <p style={{ color: "#94a3b8", fontSize: 15, lineHeight: 1.9, marginBottom: 48 }}>
        Somos un equipo con años de experiencia en la industria de manufactura y maquinaria CNC en México. Conocemos el mercado, conocemos los equipos, y sabemos lo que vale cada máquina. Por eso construimos el primer valuador automático basado en datos reales del mercado mexicano — algo que simplemente no existía.
      </p>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(190px, 1fr))", gap: 16, marginBottom: 56 }}>
        {[
          [<IconTarget />, "Especializados en CNC", "Solo maquinaria industrial CNC. No somos un clasificado genérico. Cada publicación pasa por revisión de nuestro equipo."],
          [<IconChart />, "Valuación basada en datos", "Nuestro modelo de precios considera marca, horas, control, condición y mercado mexicano. Sin especulación."],
          [<IconShield />, "Plataforma neutral", "No compramos ni vendemos maquinaria propia. Somos el puente entre quien vende y quien compra, sin conflicto de interés."],
          [<IconMegaphone />, "Marketing B2B incluido", "Nos encargamos de llevar compradores calificados a tu publicación. Tenemos presencia digital en el sector industrial mexicano."],
        ].map(([ico, tit, desc], i) => (
          <div key={i} style={{ background: S.card, border: "1px solid " + S.dim, borderRadius: 12, padding: 24 }}>
            <div style={{ marginBottom: 14 }}>{ico}</div>
            <div style={{ fontSize: 14, fontWeight: 700, color: S.text, marginBottom: 10 }}>{tit}</div>
            <div style={{ fontSize: 13, color: S.muted, lineHeight: 1.7 }}>{desc}</div>
          </div>
        ))}
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 1, marginBottom: 56 }}>
        {[["$0", "Costo de publicación"], ["10%", "Solo al vender"], ["100%", "Marketing incluido"], ["48h", "Tiempo promedio de respuesta"]].map(([n, l]) => (
          <div key={l} style={{ background: S.card, padding: "28px 20px", textAlign: "center" }}>
            <div style={{ fontSize: 34, fontWeight: 900, color: S.accent, fontFamily: S.font, marginBottom: 6 }}>{n}</div>
            <div style={{ fontSize: 12, color: S.muted, letterSpacing: 1 }}>{l}</div>
          </div>
        ))}
      </div>
      <div style={{ background: S.card, border: "1px solid " + S.dim, borderRadius: 16, padding: 32 }}>
        <div style={{ fontSize: 11, letterSpacing: 3, color: S.accent, textTransform: "uppercase", marginBottom: 12 }}>Contacto directo</div>
        <p style={{ color: S.muted, fontSize: 14, marginBottom: 24, lineHeight: 1.7 }}>
          ¿Tienes una máquina para vender, quieres saber cómo funciona el proceso, o buscas un equipo específico? Escríbenos — respondemos en menos de 24 horas.
        </p>
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
          <a href={`https://wa.me/${WA_NUMBER}?text=Hola FIERRO.MX, tengo una pregunta`} target="_blank" rel="noreferrer"
            style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "#25d366", color: "#fff", borderRadius: 8, padding: "12px 20px", fontSize: 13, fontWeight: 700, textDecoration: "none" }}>
            WhatsApp
          </a>
          <a href={`mailto:${EMAIL}`}
            style={{ display: "inline-flex", alignItems: "center", gap: 8, background: S.bg, color: S.text, border: "1px solid " + S.dim, borderRadius: 8, padding: "12px 20px", fontSize: 13, fontWeight: 600, textDecoration: "none" }}>
            <IconMail /> {EMAIL}
          </a>
        </div>
      </div>
    </div>
  );
}

// ─── APP PRINCIPAL ────────────────────────────────────────────
export default function App() {
  const [view, setView] = useState("home");
  const [catF, setCatF] = useState("Todas");
  const [condF, setCondF] = useState("Todas");
  const [maxP, setMaxP] = useState(65000);
  const [selected, setSelected] = useState(null);
  const [bidding, setBidding] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [showAuth, setShowAuth] = useState(false);
  const [user, setUser] = useState(null);
  const [dbMachines, setDbMachines] = useState([]);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null);
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
    });
    return () => subscription.unsubscribe();
  }, []);

  useEffect(() => {
    const fetchMachines = async () => {
      const { data } = await supabase
        .from("machines")
        .select("*, machine_images(url)")
        .eq("status", "active");
      if (data && data.length > 0) {
        setDbMachines(data.map(m => ({
          id: m.id,
          name: m.nombre,
          brand: m.marca,
          model: m.modelo,
          year: m.anio,
          hours: m.horas,
          price: m.precio,
          location: m.ubicacion,
          condition: m.condicion,
          category: m.categoria,
          control: m.control,
          refacciones: m.refacciones,
          desc: m.descripcion,
          image: m.machine_images?.[0]?.url || null,
        })));
      }
    };
    fetchMachines();
  }, []);

  const allMachines = dbMachines.length > 0 ? dbMachines : machines;

  const handleLogout = async () => {
    await supabase.auth.signOut();
    setUser(null);
    setView("home");
  };

  const handleVender = () => {
    if (user) setView("sell");
    else setShowAuth(true);
  };

  const filtered = allMachines.filter(m =>
    (catF === "Todas" || m.category === catF) &&
    (condF === "Todas" || m.condition === condF) &&
    m.price <= maxP
  );

  const navLinks = [["home", "Inicio"], ["nosotros", "Nosotros"], ["listings", "Comprar"], ["auctions", "Subastas"], ["valuation", "Valuar"]];

  return (
    <div style={{ background: S.bg, minHeight: "100vh", color: S.text, fontFamily: S.sans }}>

      <nav style={{ borderBottom: "1px solid " + S.border, padding: "0 20px", display: "flex", alignItems: "center", justifyContent: "space-between", height: 58, position: "sticky", top: 0, background: "#0a0f18", zIndex: 99 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }} onClick={() => setView("home")}>
          <span style={{ fontSize: 26, fontWeight: 900, letterSpacing: -1, fontFamily: S.font }}>
            <span style={{ color: S.text }}>FIERRO</span><span style={{ color: S.accent }}>.MX</span>
          </span>
          <span style={{ fontSize: 10, color: S.muted, letterSpacing: 2, marginTop: 2 }}>MAQUINARIA INDUSTRIAL</span>
        </div>

        <div className="desktop-nav" style={{ display: "flex", gap: 20, alignItems: "center" }}>
          {navLinks.map(([v, l]) => (
            <button key={v} onClick={() => setView(v)} style={{ background: "none", border: "none", color: view === v ? S.accent : S.muted, fontSize: 11, letterSpacing: 2, textTransform: "uppercase", cursor: "pointer", padding: "8px 0", borderBottom: view === v ? "2px solid " + S.accent : "2px solid transparent", fontFamily: S.font, transition: "all 0.15s" }}>
              {l}
            </button>
          ))}
          {user ? (
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <span style={{ fontSize: 11, color: S.muted, display: "flex", alignItems: "center", gap: 5 }}>
                <IconUser /> {user.email?.split("@")[0]}
              </span>
              <button onClick={handleVender} style={{ background: S.accent, color: "#000", border: "none", borderRadius: 6, padding: "8px 14px", fontSize: 11, fontWeight: 700, cursor: "pointer", letterSpacing: 1 }}>+ Vender</button>
              <button onClick={handleLogout} style={{ background: "none", border: "1px solid " + S.dim, borderRadius: 6, color: S.muted, padding: "7px 12px", fontSize: 11, cursor: "pointer" }}>Salir</button>
            </div>
          ) : (
            <div style={{ display: "flex", gap: 8 }}>
              <button onClick={() => setShowAuth(true)} style={{ background: "none", border: "1px solid " + S.dim, borderRadius: 6, color: S.muted, padding: "8px 12px", fontSize: 11, cursor: "pointer", letterSpacing: 1 }}>Entrar</button>
              <button onClick={handleVender} style={{ background: S.accent, color: "#000", border: "none", borderRadius: 6, padding: "8px 14px", fontSize: 11, fontWeight: 700, cursor: "pointer", letterSpacing: 1 }}>+ Vender</button>
            </div>
          )}
        </div>
        <button className="mobile-menu-btn" onClick={() => setMenuOpen(!menuOpen)} style={{ background: "none", border: "none", color: S.text, fontSize: 22, cursor: "pointer" }}>
          {menuOpen ? "✕" : "☰"}
        </button>
      </nav>

      {menuOpen && (
        <div style={{ background: "#0a0f18", borderBottom: "1px solid " + S.border, padding: "12px 20px", display: "flex", flexDirection: "column", gap: 4, zIndex: 98 }}>
          {navLinks.map(([v, l]) => (
            <button key={v} onClick={() => { setView(v); setMenuOpen(false); }} style={{ background: "none", border: "none", color: view === v ? S.accent : S.muted, fontSize: 14, textAlign: "left", cursor: "pointer", padding: "12px 0", borderBottom: "1px solid " + S.dim, fontFamily: S.font }}>
              {l}
            </button>
          ))}
          <button onClick={() => { handleVender(); setMenuOpen(false); }} style={{ background: S.accent, color: "#000", border: "none", borderRadius: 6, padding: "12px", fontSize: 13, fontWeight: 700, cursor: "pointer", marginTop: 8 }}>+ Publicar máquina</button>
          {user && <button onClick={handleLogout} style={{ background: "none", border: "1px solid " + S.dim, borderRadius: 6, color: S.muted, padding: "10px", fontSize: 12, cursor: "pointer", marginTop: 4 }}>Cerrar sesión</button>}
        </div>
      )}

      {view === "home" && (
        <div>
          <div style={{ padding: "60px 20px 48px", maxWidth: 680, margin: "0 auto", textAlign: "center" }}>
            <div style={{ fontSize: 11, letterSpacing: 5, color: S.accent, textTransform: "uppercase", marginBottom: 20 }}>El marketplace B2B de México</div>
            <h1 style={{ fontSize: "clamp(32px, 6vw, 52px)", fontWeight: 900, color: "#ffffff", margin: "0 0 20px", lineHeight: 1.05, letterSpacing: -2 }}>
              Compra y vende<br />maquinaria CNC<br />sin intermediarios
            </h1>
            <p style={{ color: S.muted, fontSize: 15, lineHeight: 1.8, marginBottom: 36, maxWidth: 460, margin: "0 auto 36px" }}>
              Plataforma especializada B2B. Valuación automática, subastas en tiempo real, comisión solo al vender.
            </p>
            <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
              <button onClick={() => setView("listings")} style={{ background: S.accent, color: "#000", border: "none", borderRadius: 8, padding: "14px 28px", fontSize: 13, fontWeight: 700, cursor: "pointer" }}>Ver máquinas</button>
              <button onClick={() => setView("auctions")} style={{ background: "transparent", color: S.accent, border: "1px solid " + S.accent, borderRadius: 8, padding: "14px 28px", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>Ver subastas</button>
            </div>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", maxWidth: 900, margin: "0 auto 64px", padding: "0 20px", gap: 1 }}>
            {[["$0", "Costo de publicación"], ["10%", "Comisión al vender"], [allMachines.length + "+", "Máquinas disponibles"], [auctions.length, "Subastas activas"]].map(([n, l]) => (
              <div key={l} style={{ background: S.card, padding: "28px 20px", textAlign: "center" }}>
                <div style={{ fontSize: 36, fontWeight: 900, color: S.accent, fontFamily: S.font, marginBottom: 6 }}>{n}</div>
                <div style={{ fontSize: 11, color: S.muted, letterSpacing: 1 }}>{l}</div>
              </div>
            ))}
          </div>
          <div style={{ maxWidth: 940, margin: "0 auto 40px", padding: "0 20px" }}>
            <div style={{ fontSize: 11, letterSpacing: 3, color: S.muted, textTransform: "uppercase", marginBottom: 20 }}>Subastas terminando pronto</div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 16, marginBottom: 40 }}>
              {auctions.map(a => <AuctionCard key={a.id} a={a} onBid={setBidding} />)}
            </div>
            <div style={{ fontSize: 11, letterSpacing: 3, color: S.muted, textTransform: "uppercase", marginBottom: 20 }}>Compra directa destacada</div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 16 }}>
              {allMachines.slice(0, 3).map(m => <MachineCard key={m.id} m={m} onClick={setSelected} />)}
            </div>
          </div>
        </div>
      )}

      {view === "listings" && (
        <div style={{ maxWidth: 1100, margin: "0 auto", padding: "40px 20px" }}>
          <div style={{ marginBottom: 28 }}>
            <div style={{ fontSize: 11, letterSpacing: 3, color: S.accent, textTransform: "uppercase", marginBottom: 6 }}>Inventario</div>
            <h2 style={{ fontSize: 26, fontWeight: 800, color: S.text, margin: 0 }}>Compra directa</h2>
          </div>
          <div style={{ display: "flex", gap: 16, marginBottom: 28, flexWrap: "wrap", alignItems: "flex-end" }}>
            {[["Categoría", catF, setCatF, categories], ["Condición", condF, setCondF, conditions]].map(([lbl, val, setter, opts]) => (
              <div key={lbl}>
                <Label>{lbl}</Label>
                <select value={val} onChange={e => setter(e.target.value)}
                  style={{ background: S.card, border: "1px solid " + S.dim, borderRadius: 6, color: S.text, padding: "9px 12px", fontSize: 12, fontFamily: S.font }}>
                  {opts.map(o => <option key={o}>{o}</option>)}
                </select>
              </div>
            ))}
            <div>
              <Label>Precio max: ${maxP.toLocaleString()} USD</Label>
              <input type="range" min="5000" max="65000" step="1000" value={maxP} onChange={e => setMaxP(+e.target.value)}
                style={{ width: 160, accentColor: S.accent, marginTop: 4 }} />
            </div>
          </div>
          <div style={{ fontSize: 11, color: S.muted, marginBottom: 16 }}>{filtered.length} resultado{filtered.length !== 1 ? "s" : ""}</div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 16 }}>
            {filtered.map(m => <MachineCard key={m.id} m={m} onClick={setSelected} />)}
          </div>
        </div>
      )}

      {view === "auctions" && (
        <div style={{ maxWidth: 1100, margin: "0 auto", padding: "40px 20px" }}>
          <div style={{ marginBottom: 28 }}>
            <div style={{ fontSize: 11, letterSpacing: 3, color: S.accent, textTransform: "uppercase", marginBottom: 6 }}>En vivo</div>
            <h2 style={{ fontSize: 26, fontWeight: 800, color: S.text, margin: "0 0 8px" }}>Subastas activas</h2>
            <p style={{ color: S.muted, fontSize: 14 }}>Precio de salida bajo. Gana si tienes la puja más alta al cierre. Comisión 10% solo para el ganador.</p>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 16 }}>
            {auctions.map(a => <AuctionCard key={a.id} a={a} onBid={setBidding} />)}
          </div>
        </div>
      )}

      {view === "valuation" && <Valuation />}
      {view === "nosotros" && <QuienesSomos />}
      {view === "sell" && <PublishForm user={user} onClose={() => setView("home")} />}

      {selected && <DetailModal m={selected} onClose={() => setSelected(null)} />}
      {bidding && <BidModal a={bidding} onClose={() => setBidding(null)} />}
      {showAuth && <AuthModal onClose={() => setShowAuth(false)} onSuccess={() => setView("sell")} />}

      <a href={`https://wa.me/${WA_NUMBER}?text=Hola FIERRO.MX, tengo una pregunta`} target="_blank" rel="noreferrer"
        style={{ position: "fixed", bottom: 24, right: 24, background: "#25d366", color: "#fff", borderRadius: "50%", width: 56, height: 56, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 26, textDecoration: "none", boxShadow: "0 4px 20px #25d36660", zIndex: 999 }}>
        💬
      </a>

      <style>{`
        @media (max-width: 640px) { .desktop-nav { display: none !important; } .mobile-menu-btn { display: block !important; } }
        @media (min-width: 641px) { .mobile-menu-btn { display: none !important; } }
        * { box-sizing: border-box; }
        select option { background: #1a2535; }
        body { margin: 0; font-size: 16px; }
      `}</style>
    </div>
  );
}